export const API_URL = window.location.hostname === "localhost" ? "http://localhost:8181" : "https://modern-yoga-swv9.vercel.app";
console.log(
    "API_URL :",
    API_URL
);